import {
  BulkMessageLocationEnum,
  BulkMessageStartTermInput,
  BulkMessageStudentSourceEnum,
  BulkMessageSenderInput,
  EntryTermEnum,
  PredictionIndexEnum,
  StudentTypeEnum,
  MessagingYesNoEnum,
  BulkMessageSendOptionInput,
  MessagePartInput,
  Student,
} from "@/__generated__/graphql";
import { FilterDataType, InputType } from "@/components/FilterSidebar/types";
import { SelectOption } from "@/components/FormInputs/types";
import { FunnelStateMapsType } from "@/util/funnelGroups";
import { z } from "zod/v4";

export type MessagePartInputExtended =
  | MessagePartInput
  | {
      create?: never;
      update: {
        messagePartId: string;
        body:
          | { text: string; url: never | undefined }
          | { url: string; text: never | undefined };
      };
    };

export interface FormValues {
  name?: string;
  filters: FormValuesFilters;
  sender?: BulkMessageSenderInput;
  sendOption?: BulkMessageSendOptionInput;
  messageParts?: MessagePartInputExtended[];
}

export interface FormValuesFilters {
  firstTimeMessageRecipients?: MessagingYesNoEnum;
  assignedCounselors?: string[];
  commitIndex?: PredictionIndexEnum[];
  funnelStates?: FormFunnelState[];
  interests?: string[];
  location?: BulkMessageLocationEnum[];
  majors?: string[];
  startTerm?: BulkMessageStartTermInput[];
  studentSource?: BulkMessageStudentSourceEnum[];
  studentType?: StudentTypeEnum[];
  userIds?: string[];
  riseActionId?: string;
}

export type FormFunnelState = keyof FunnelStateMapsType["SIDEBAR"];

export interface FilterGroup {
  title: string;
  filters: FilterInput[];
}

export interface FilterInput {
  label: string;
  name: FilterName;
  type: InputType;
  placeholder?: string;
  defaultValue: FilterDataType;
  disableSearch?: boolean;
  options?: SelectOption[];
  tokenIsValid?: (val: string) => boolean;
}

export interface FilterInputData {
  assignedCounselors?: string[];
  cohortYear?: string[];
  commitIndex?: PredictionIndexEnum[];
  entryTerm?: EntryTermEnum[];
  funnelStates?: FormFunnelState[];
  interests?: string[];
  location?: BulkMessageLocationEnum[];
  majors?: string[];
  studentSource?: BulkMessageStudentSourceEnum[];
  studentType?: StudentTypeEnum[];
}

export type FilterName = keyof FilterInputData;

export interface SubmissionReturn {
  id?: string;
  result?: SubmissionResult;
  draft?: boolean | null;
  audienceReach: {
    students: Student[];
    totalCount: number;
  };
}

export interface SubmissionResult {
  success: boolean;
  errors: {
    message: string;
    title: string;
  }[];
}

export type BulkMessageSendFilterType =
  | "studentFilters"
  | "csvImport"
  | "riseActionSend";

export const BulkMessageComposeState = z.object({
  riseActionId: z.optional(z.string()),
});

export type BulkMessageComposeState = z.infer<typeof BulkMessageComposeState>;
